import { createFileRoute } from '@tanstack/react-router'

import { AnalyticsPerformanceTabPanel } from '@/analytics/components/AnalyticsPerformanceTabPanel/AnalyticsPerformanceTabPanel'
import { TRACK_ANALYTICS_DASHBOARD_PAGE_NAVIGATED } from '@/core/constants/constants'
import { track } from '@/core/utils/tracking/track'

export const Route = createFileRoute(
  '/company/_management/analytics/performance',
)({
  component: AnalyticsPerformanceTabPanel,
  onEnter: () => {
    track(TRACK_ANALYTICS_DASHBOARD_PAGE_NAVIGATED, {
      dashboard_page: 'performance',
    })
  },
})
